import { StyleSheet, Platform } from 'react-native';
import { checkStyles } from '../func';
import { IGptConversation } from '../../GptConversation/hook';

const createStyles = ({
  attributes,
  width,
  height,
  style,
}: Pick<IGptConversation, 'attributes' | 'width' | 'height'> & {
  style?: any;
}) => {
  const { opacity, sendButton, borderRadius, backgroundColor } = attributes;

  // Merge sendButton with its styles
  const finalSendButton = {
    ...sendButton,
    ...(sendButton.styles && sendButton.styles),
  };

  return StyleSheet.create({
    container: {
      width: style?.width || width,
      height: style?.height || height,
      opacity: style?.opacity !== undefined ? style.opacity : opacity,
      backgroundColor: style?.backgroundColor || backgroundColor,
      paddingBottom: 8,
    },

    scrollContainer: {
      height: (style?.height || height) - 60,
      paddingTop: 24,
      borderRadius: 8,
      paddingHorizontal: 20,
    },

    buttonInputContainer: {
      marginTop: 4,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      paddingVertical: 8,
    },

    input: {
      fontSize: style?.fontSize || 14,
      paddingVertical: Platform.OS === 'android' ? 0 : 8,
      paddingHorizontal: 8,
      backgroundColor: '#fff',
      flex: 1,
      marginRight: 8,
      borderRadius: style?.borderRadius || borderRadius,
      height: 38,
    },

    btn: {
      justifyContent: 'center',
      lineHeight: finalSendButton.lineHeight || sendButton.lineHeight,
      ...checkStyles({
        ...finalSendButton,
        borderRadius: style?.borderRadius || borderRadius,
      }),
      maxWidth: '50%',
      fontWeight: '700',
      height: 38,
    },
    btnIcon: {
      ...checkStyles({
        ...finalSendButton,
        borderRadius: style?.borderRadius || borderRadius,
      }),
      backgroundColor: '#fff',
      height: 38,
      opacity: 1,
      margin: 0,
      marginRight: 8,
    },
    btnText: {
      lineHeight: finalSendButton.lineHeight || sendButton.lineHeight,
      ...checkStyles(finalSendButton),
    },
  });
};

export default createStyles;
